



















































































































































































































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';
import { egbStrings, tipoTelefoneIcons } from '../../utils/constants';
import { calculoIdadeGestacional } from '../../utils/functions';

import {
  Egb, InternacaoSuspenderAltaFormData, TipoInformacaoParto, TipoTelefone,
} from '../../../../back/src/types';
import { InformacaoParto } from '../../../../back/src/entity/InformacaoParto';

import Carregando from '../../components/Carregando.vue';
import Confirmar from '../../components/Confirmar.vue';
import CustomDialog from '../../components/CustomDialog.vue';
import IfEmptyTextPrintNA from '../../components/IfEmptyTextPrintNA.vue';
import ThePacientesResumo from '../../components/pacientes/ThePacientesResumo.vue';
import ThePacientesObservacoesAlert from '../../components/pacientes/ThePacientesObservacoesAlert.vue';
import TheGestacoesDadosFinalizada from '../../components/gestacoes/TheGestacoesDadosFinalizada.vue';
import TheInternacoesEditForm from '../../components/internacoes/TheInternacoesEditForm.vue';
import TheInternacoesIniciarForm from '../../components/internacoes/TheInternacoesIniciarForm.vue';
import TheInternacoesPreverAltaForm from '../../components/internacoes/TheInternacoesPreverAltaForm.vue';
import TheInternacoesCancelarForm from '../../components/internacoes/TheInternacoesCancelarForm.vue';
import InformacoesPartosForm from '../../components/informacoes_partos/InformacoesPartosForm.vue';
import InformacoesPartosTabela from '../../components/informacoes_partos/InformacoesPartosTabela.vue';
import { Gestacao } from '../../../../back/src/entity/Gestacao';

export default Vue.extend({
  name: 'InternacoesVer',
  components: {
    Carregando,
    Confirmar,
    CustomDialog,
    IfEmptyTextPrintNA,
    ThePacientesResumo,
    ThePacientesObservacoesAlert,
    TheGestacoesDadosFinalizada,
    TheInternacoesEditForm,
    TheInternacoesIniciarForm,
    TheInternacoesPreverAltaForm,
    TheInternacoesCancelarForm,
    InformacoesPartosForm,
    InformacoesPartosTabela,
  },
  data: () => ({
    loading: {
      internacao: true,
      tipoSanguineo: true,
      alergias: true,
    },
    dialogRegistrar: false,
    tipoInformacaoParto: null,
    dialogIniciar: false,
    dialogPreverAlta: false,
    dialogCancelar: false,
    editInternacao: false,
    showInternacao: true,
    showGestante: true,
    showGestacao: true,
    showPpp: true,
    internacao: null,
    tipoSanguineo: null,
    alergias: null,
  }),
  computed: {
    internacaoId() {
      return _.get(this.$route.params, 'internacaoId', null);
    },
    igGestacao() {
      return calculoIdadeGestacional(this.internacao.gestacao, null, true);
    },
    alergiasResposta() {
      if (!this.alergias) {
        return '';
      }
      const resposta = _.get(this.alergias.historico_pergunta.opcoes, this.alergias.resposta, null);
      const { observacoes } = this.alergias;
      if (observacoes) {
        return `${resposta} - ${observacoes}`;
      }
      return resposta;
    },
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
  },
  mounted() {
    this.getInternacao();
  },
  methods: {
    gestacaoFinalizadaAtualizada(gestacao: Gestacao) {
      this.internacao.gestacao = gestacao;
    },
    linkWhatsapp(telefone: string) {
      if (this.$vuetify.breakpoint.xsOnly) {
        return `https://api.whatsapp.com/send?phone=55${telefone.replace(/\D/g, '')}`;
      }
      return `https://web.whatsapp.com/send?phone=55${telefone.replace(/\D/g, '')}`;
    },
    tipoTelefoneIcons(tipoTelfone: TipoTelefone) {
      if (_.has(tipoTelefoneIcons, tipoTelfone)) {
        return tipoTelefoneIcons[tipoTelfone];
      }
      return null;
    },
    egbStrings(egb: Egb) {
      if (_.has(egbStrings, egb)) {
        return egbStrings[egb];
      }
      return null;
    },
    registrarEvolucao() {
      this.tipoInformacaoParto = TipoInformacaoParto.EVOLUCAO;
      this.dialogRegistrar = true;
    },
    registrarVisita() {
      this.tipoInformacaoParto = TipoInformacaoParto.VISITA;
      this.dialogRegistrar = true;
    },
    novaInformacaoParto(informacaoParto: InformacaoParto) {
      this.dialogRegistrar = false;
      if (_.has(this.internacao, 'paciente.informacoes_parto')) {
        this.internacao.paciente.informacoes_parto.push(informacaoParto);
      }
    },
    atualizaInternacao() {
      this.editInternacao = false;
      this.dialogPreverAlta = false;
      this.getInternacao();
    },
    finalizaGestacao() {
      this.getInternacao();
    },
    // eslint-disable-next-line func-names
    suspenderAltaDebounce: _.debounce(async function () { await this.suspenderAlta(); }, 200),
    async suspenderAlta() {
      const dataAlta = moment(this.internacao.data_previsao_alta).utc().format('DD/MM/YYYY');
      if (await this.confirmar.open(
        'Suspender alta',
        `Tem certeza que deseja suspender a alta prevista (${dataAlta}) desta paciente?`,
      ) === false) {
        return;
      }
      const formData: InternacaoSuspenderAltaFormData = {
        id: this.internacao.id,
      };
      this.loading.suspenderAlta = true;
      try {
        const response = await Requester.internacao.suspenderAltaInternacao(
          this.internacao.id, formData,
        );
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Internação atualizada com sucesso.' });
          this.atualizaInternacao();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.suspenderAlta = false;
      }
    },
    async getInternacao() {
      this.loading.internacao = true;
      try {
        const response = await Requester.internacao.buscaInternacao(this.internacaoId);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          this.$router.push({ name: 'InternacoesIndex' });
        } else {
          this.internacao = response.data;
          this.getTipoSanguineo(this.internacao.paciente_id);
          this.getAlergias(this.internacao.paciente_id);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.internacao = false;
      }
    },
    async getTipoSanguineo(pacienteId) {
      this.loading.tipoSanguineo = true;
      try {
        const response = await Requester.paciente.tipoSanguineo(pacienteId);
        if (response.errors.length > 0) {
          this.tipoSanguineo = null;
        } else {
          this.tipoSanguineo = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.tipoSanguineo = false;
      }
    },
    async getAlergias(pacienteId) {
      this.loading.alergias = true;
      try {
        const response = await Requester.paciente.historicoResposta(pacienteId, 1);
        if (response.errors.length > 0) {
          this.alergias = null;
        } else {
          this.alergias = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.alergias = false;
      }
    },
  },
});
